/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How accurate is the Navy method?`)
};

const es_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué precisión tiene el método de la Marina?`)
};

const de_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie genau ist die Navy-Methode?`)
};

const nl_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe nauwkeurig is de Navy-methode?`)
};

const fr_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la précision de la méthode Navy ?`)
};

const it_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto è preciso il metodo della Marina?`)
};

const pt_br2_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a precisão do método da Marinha?`)
};

const pt_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quão preciso é o método da Marinha?`)
};

const ja_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`米海軍式の精度はどのくらいですか?`)
};

const zh_bf_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海军法有多准确？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_faq_q1", locale)
	if (locale === "en") return en_bf_faq_q1(inputs)
	if (locale === "es") return es_bf_faq_q1(inputs)
	if (locale === "de") return de_bf_faq_q1(inputs)
	if (locale === "nl") return nl_bf_faq_q1(inputs)
	if (locale === "fr") return fr_bf_faq_q1(inputs)
	if (locale === "it") return it_bf_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_bf_faq_q1(inputs)
	if (locale === "pt") return pt_bf_faq_q1(inputs)
	if (locale === "ja") return ja_bf_faq_q1(inputs)
	return zh_bf_faq_q1(inputs)
};